import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.object.assign.js";
var _excluded = ["children", "onChange", "formControl", "checked", "disabled", "ariaLabel"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2017,2020. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { Checkbox } from '..';
var CardControl = function CardControl(_ref) {
  var children = _ref.children,
    onChange = _ref.onChange,
    formControl = _ref.formControl,
    checked = _ref.checked,
    disabled = _ref.disabled,
    ariaLabel = _ref.ariaLabel,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("div", _extends({
    className: "wds-c-card__control"
  }, otherProps), formControl || /*#__PURE__*/React.createElement(Checkbox, {
    checked: checked,
    disabled: disabled,
    label: ariaLabel,
    small: true,
    isFormItem: false,
    onChange: onChange
  }), children);
};
CardControl.propTypes = {
  /** children */
  children: PropTypes.node,
  /** a form control serving as the card control */
  formControl: PropTypes.node,
  /** onChange callback */
  onChange: PropTypes.func,
  /** control Checkbox is checked */
  checked: PropTypes.bool,
  /** control Checkbox is disabled */
  disabled: PropTypes.bool,
  /** describes the control Checkbox */
  ariaLabel: PropTypes.string.isRequired
};
CardControl.defaultProps = {
  children: undefined,
  onChange: function onChange() {},
  formControl: undefined,
  checked: false,
  disabled: false
};
CardControl.displayName = 'CardControl';
export default CardControl;